"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = require("babel-runtime/helpers/defineProperty");

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require("react-redux");

var _config = require("../../config");

var _config2 = _interopRequireDefault(_config);

var _hubspot = require("../../redux/modules/hubspot");

var _utils = require("../../utils");

var _SiteFooter = require("./component/SiteFooter");

var _SiteFooter2 = _interopRequireDefault(_SiteFooter);

var _eol = require("../../redux/modules/eol");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SiteFooterNew = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    user: state.user,
    loggedIn: state.auth.loggedIn,
    logos: state.companyLogos.megascans_footer_logos,
    eol: state.eol
  };
}, { subscribeHubspot: _hubspot.subscribeHubspot, getLatestMixerBuildUrl: _utils.getLatestMixerBuildUrl }), _dec(_class = (_temp = _class2 = function (_React$Component) {
  (0, _inherits3.default)(SiteFooterNew, _React$Component);

  function SiteFooterNew(props) {
    var _this$state;

    (0, _classCallCheck3.default)(this, SiteFooterNew);

    var _this = (0, _possibleConstructorReturn3.default)(this, (SiteFooterNew.__proto__ || (0, _getPrototypeOf2.default)(SiteFooterNew)).call(this, props));

    _this.onChangeHandler = _this.onChangeHandler.bind(_this);
    _this.state = (_this$state = {
      subscriberEmail: "",
      subscribed: false
    }, (0, _defineProperty3.default)(_this$state, "subscriberEmail", ""), (0, _defineProperty3.default)(_this$state, "logos", []), _this$state);
    return _this;
  }

  (0, _createClass3.default)(SiteFooterNew, [{
    key: "onChangeHandler",
    value: function onChangeHandler(ev) {
      this.setState({
        subscriberEmail: ev.target.value,
        subscribed: false
      });
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.stateUpdated !== this.props.stateUpdated) {
        this.setState({ subscriberEmail: "" });
      }
      if (this.props.logos !== nextProps.logos) {
        this.setState({
          logos: nextProps.logos
        });
        return true;
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var footerContent = {
        logoSrc: "https://quixel.com/quixel_icon.svg",
        logoAlt: "Quixel logo",

        smallLinks: [{ label: "Legal", href: "/terms" }, { label: "Privacy", href: "/terms#privacy-policy" }, { label: "Cookies", href: "/cookiepolicy" }],

        copyrights: "\xA9 " + new Date().getFullYear() + ", Epic Games, Inc. Quixel, Megascans, and Unreal Engine are trademarks or registered trademarks of Epic Games, Inc. in the USA and elsewhere.",

        columns: [{
          title: "EXPLORE",
          links: [{ label: "Fab", href: _config2.default.fabUrl, newWindow: true }, { label: "Megascans", href: "/megascans/home" }, { label: "Bridge", href: (0, _utils.getLatestBridgeBuildUrl)() }, { label: "Mixer", href: this.props.getLatestMixerBuildUrl() }, (0, _eol.getIsPricingEnabled)(this.props.eol.eolConfig) ? { label: "Pricing", href: "/pricing" } : {}]
        }, {
          title: "COMMUNITY",
          links: [{
            label: "Forum",
            href: "https://forums.unrealengine.com/tags/c/development-discussion/quixel-megascans/200/unreal-engine",
            newWindow: true
          }]
        }, {
          title: "SUPPORT",
          links: [{
            label: "Quixel Support",
            href: _config2.default.forumBaseUrl,
            newWindow: true
          }, {
            label: "Fab Support",
            href: "https://support.fab.com/s/?ProductOrigin=FabSupport",
            newWindow: true
          }, {
            label: "Fab Documentation",
            href: "https://dev.epicgames.com/documentation/en-us/fab/fab-documentation",
            newWindow: true
          }, { label: "Sign In", href: "/login" }]
        }],

        socialLinks: [{
          icon: __CLIENT__ ? "facebook.svg" : "",
          href: "https://www.facebook.com/quixelofficial",
          onClick: function onClick() {
            if (window && _epicTracking) {
              window.trackEpicIntrection({
                eventCategory: "Engagement",
                eventAction: "Social",
                eventLabel: "Facebook",
                interactionType: "click",
                eventValue: 1
              });
            }
          }
        }, {
          icon: __CLIENT__ ? "twitter.svg" : "",
          href: "https://twitter.com/quixeltools",
          onClick: function onClick() {
            if (window && _epicTracking) {
              window.trackEpicIntrection({
                eventCategory: "Engagement",
                eventAction: "Social",
                eventLabel: "Twitter",
                interactionType: "click",
                eventValue: 1
              });
            }
          }
        }, {
          icon: __CLIENT__ ? "instagram.svg" : "",
          href: "https://www.instagram.com/quixelofficial/",
          onClick: function onClick() {
            if (window && _epicTracking) {
              window.trackEpicIntrection({
                eventCategory: "Engagement",
                eventAction: "Social",
                eventLabel: "Instagram",
                interactionType: "click",
                eventValue: 1
              });
            }
          }
        }, {
          icon: __CLIENT__ ? "youtube.svg" : "",
          href: "https://www.youtube.com/quixeltools",
          onClick: function onClick() {
            if (window && _epicTracking) {
              window.trackEpicIntrection({
                eventCategory: "Engagement",
                eventAction: "Social",
                eventLabel: "Youtube",
                interactionType: "click",
                eventValue: 1
              });
            }
          }
        }, {
          icon: __CLIENT__ ? "linkedin.svg" : "",
          href: "https://www.linkedin.com/company/quixeltools",
          onClick: function onClick() {
            if (window && _epicTracking) {
              window.trackEpicIntrection({
                eventCategory: "Engagement",
                eventAction: "Social",
                eventLabel: "Linkedin",
                interactionType: "click",
                eventValue: 1
              });
            }
          }
        }],
        subscribeLink: "https://quixel.us2.list-manage.com/subscribe/post?u=51f3f8f549d56efa029aa222d&id=fabeeb6e86"
      };

      return _react2.default.createElement(_SiteFooter2.default, (0, _extends3.default)({
        newHome: true,
        onChange: this.onChangeHandler,
        subscriberEmail: this.state.subscriberEmail,
        subscribed: this.state.subscribed,
        onClickHandler: function onClickHandler() {
          function validateEmail(email) {
            var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(email);
          }
          if (validateEmail(_this2.state.subscriberEmail)) {
            _this2.props.subscribeHubspot(_this2.state.subscriberEmail).then(function () {
              if (window && _epicTracking) {
                window.trackEpicIntrection({
                  eventCategory: "Forms",
                  eventAction: "Newsletter",
                  interactionType: "click",
                  eventValue: 1
                });
              }
            });
            _this2.setState({
              subscriberEmail: "",
              subscribed: true
            });
          }
        }
      }, footerContent));
    }
  }]);
  return SiteFooterNew;
}(_react2.default.Component), _class2.contextTypes = {
  router: _react2.default.PropTypes.object,
  dialogs: _react2.default.PropTypes.object
}, _temp)) || _class);
exports.default = SiteFooterNew;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/SiteFooterNew/SiteFooterNew.jsx
// module id = 2663
// module chunks = 0